import { render } from "./index.vue?vue&type=template&id=9f0d417c&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=9f0d417c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f0d417c"]])

export default __exports__